import DashboardComponent from '../../../../../components/Dashboard/DashboardComponent';
import i18next from 'i18next';
import DashboardLogo from '../../../../../components/Shared/Icons/DashboardLogo';
import permissions from '../../../../permissions';
import PopulationHealth from '../../../../../components/PopulationHealth';
import Monitoring from '../../../../../components/Shared/Icons/Monitoring';
// TEMP: Assessment Performance backport (2026-05-07).
// Replace this lazy import with `@pages/assessment-performance` when
// refactor/mui-v9-migration merges into development.
import AssessmentPerformance from '../../../../../components/AssessmentPerformance';

const DASHBOARD_ROUTES_ROOT = {
  path: '/:currentAccountUuid/dashboard',
  exact: true,
  additional: {
    component: DashboardComponent,
    title: i18next.t('titles:dashboard'),
    protected: true,
    icon: DashboardLogo,
    permission: permissions.DASHBOARD_GET,
    disabledId: 'dashboard',
  },
};

const DASHBOARD_ROUTES_POPULATION_HEALTH = {
  path: '/:currentAccountUuid/populationHealth',
  exact: true,
  additional: {
    component: PopulationHealth,
    title: i18next.t('titles:populationHealth'),
    protected: true,
    icon: Monitoring,
    permission: permissions.ADMIN_PATIENT_IMPORT,
    disabledId: 'populationHealth',
  },
};

// TEMP: Assessment Performance backport (2026-05-07).
// Gated on the dedicated `ASSESSMENT_PERFORMANCE_VIEW` permission
// (bit 53, defined in src/config/permissions.js). The matching
// backend gate is on `QHSPermissionType.ASSESSMENT_PERFORMANCE_VIEW`.
// Until ops grants bit 53 to roles in production the dashboard is
// hidden from the sidebar for everyone — direct URL access still
// renders the page (ProtectedRoute is intentionally not gated on
// development, see backport notes).
const DASHBOARD_ROUTES_ASSESSMENT_PERFORMANCE = {
  path: '/:currentAccountUuid/assessment-performance',
  exact: true,
  additional: {
    component: AssessmentPerformance,
    title: i18next.t('titles:assessmentPerformance'),
    protected: true,
    icon: Monitoring,
    permission: permissions.ASSESSMENT_PERFORMANCE_VIEW,
    disabledId: 'assessmentPerformance',
  },
};

export const DASHBOARD_ROUTES = {
  // ------- For child accounts ------
  // ...

  // ------- For current accounts ------
  root: DASHBOARD_ROUTES_ROOT,
  populationHealth: DASHBOARD_ROUTES_POPULATION_HEALTH,
  // TEMP: Assessment Performance backport (2026-05-07) — orphan after FSD merge.
  assessmentPerformance: DASHBOARD_ROUTES_ASSESSMENT_PERFORMANCE,
};

